var MyClass = function MyClass(c) {};

MyClass._r = [0, [{
  a: {
    b: String
  }
}]];
MyClass.displayName = "MyClass";

var MyClass2 = function MyClass2() {};

MyClass2.displayName = "MyClass2";

var MyClass3 = function MyClass3() {};

MyClass3.displayName = "MyClass3";